import React from 'react';

class HeaderAboveContent extends React.Component {
	render() {
		return null;
	}
}

export default HeaderAboveContent;
